import React, { type FC } from "react";

import { type Filters } from "../../../utils/queryUtils";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { getEventFilters } from "./eventFilters";

export interface EventFilterFormProps {
  filterOptions: Filters;
  updateFilter: (filter: Filters) => void;
  filter: Filters;
  onValidationChange?: (propertyName: string, isValid: boolean) => void;
}
export const EventFilterForm: FC<EventFilterFormProps> = ({
  filterOptions,
  filter,
  updateFilter,
  onValidationChange,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getEventFilters()}
    onValidationChange={onValidationChange}
  />
);
